import { useEffect, useState } from "react";

import type { AdminListPagination, AdminWebhookEventSummary } from "@chaochud/contracts";

import { DataTable, PageHeader } from "@/components/admin-ui";
import { adminOpsClient } from "@/lib/api-clients";

export function WebhooksPage() {
  const [items, setItems] = useState<AdminWebhookEventSummary[]>([]);
  const [pagination, setPagination] = useState<AdminListPagination | null>(null);
  const [page, setPage] = useState(1);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void adminOpsClient
      .listWebhookEvents(page)
      .then((data) => {
        setItems(data.items);
        setPagination(data.pagination);
      })
      .catch((err) => setError(err instanceof Error ? err.message : "โหลดไม่สำเร็จ"));
  }, [page]);

  return (
    <div className="space-y-6">
      <PageHeader title="Webhook Events" />
      {error ? <p className="text-sm text-error-text">{error}</p> : null}
      <DataTable
        headers={["Provider", "Event", "Provider event id", "Processed"]}
        rows={items.map((item) => [
          item.provider,
          item.eventType,
          item.providerEventId,
          item.processedAt ? new Date(item.processedAt).toLocaleString("th-TH") : "-",
        ])}
        pagination={pagination ?? undefined}
        onPageChange={setPage}
      />
    </div>
  );
}
